import { ReactComponent as DragAndDropBanner } from "./drag-and-drop-banner.svg";

export default DragAndDropBanner;
